import { useEffect, useRef } from 'react';
export default function useKeyPressed(initKeysToActions) {
  const keysToActions = useRef(initKeysToActions);
  useEffect(() => {
    function handler(_ref) {
      let {
        key
      } = _ref;
      Object.keys(keysToActions.current).forEach(keyToAction => {
        if (key === keyToAction) {
          keysToActions.current[keyToAction]();
        }
      });
    }

    window.addEventListener('keydown', handler);
    return () => {
      window.removeEventListener('keydown', handler);
    };
  }, [keysToActions]);
}